import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M13.3003 10.9554C12.4303 5.19538 10.4803 1.55538 7.07031 1.04538C2.13031 0.305379 -1.22969 8.68538 2.77031 21.0954C4.80031 27.4054 7.75031 29.7154 10.1303 29.3754C14.0403 28.8254 15.0503 22.5954 13.3003 10.9554Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M3.43009 14.8254C3.43009 14.8254 2.58009 7.61539 4.99009 6.27539C7.03009 5.13539 8.88009 8.61539 10.5901 21.9654"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M3.43024 14.8254C3.03024 12.6054 2.83024 10.3254 3.38024 8.02543C3.54024 7.45543 3.75024 6.86543 4.20024 6.36543C4.42024 6.11543 4.71024 5.89543 5.03024 5.76543C5.36024 5.62543 5.78024 5.57543 6.16024 5.68543C6.92024 5.93543 7.31024 6.50543 7.64024 7.00543C7.96024 7.52543 8.20024 8.06543 8.41024 8.60543C9.20024 10.7854 9.64024 13.0054 9.96024 15.2354C10.1102 16.3554 10.2502 17.4754 10.3702 18.5954C10.4502 19.7154 10.5602 20.8354 10.5902 21.9654L9.20024 15.3754C8.70024 13.1954 8.24024 11.0054 7.48024 8.95543C7.29024 8.44543 7.07024 7.95543 6.81024 7.51543C6.55024 7.07543 6.21024 6.69543 5.89024 6.58543C5.59024 6.46543 5.15024 6.63543 4.84024 6.95543C4.52024 7.27543 4.28024 7.74543 4.10024 8.24543C3.75024 9.25543 3.61024 10.3654 3.53024 11.4654C3.42024 12.5754 3.42024 13.6954 3.43024 14.8254Z"
        fill={outline}
      />
      <path
        d="M60.5401 10.9553C61.4101 5.19533 63.3601 1.55533 66.7701 1.04533C71.7101 0.30533 75.0701 8.69533 71.0701 21.1053C69.0401 27.4153 66.0901 29.7253 63.7101 29.3853C59.8101 28.8253 58.7901 22.5953 60.5401 10.9553Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M70.41 14.8253C70.41 14.8253 71.26 7.61527 68.85 6.27527C66.81 5.13527 64.96 8.61527 63.25 21.9653"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M70.4098 14.8253C70.4198 13.6953 70.4098 12.5753 70.3098 11.4653C70.2298 10.3653 70.0898 9.24529 69.7398 8.24529C69.5598 7.74529 69.3198 7.27529 69.0098 6.95529C68.6998 6.63529 68.2598 6.45529 67.9598 6.58529C67.6398 6.69529 67.2898 7.08529 67.0398 7.51529C66.7698 7.95529 66.5598 8.44529 66.3698 8.95529C65.6098 10.9953 65.1398 13.1953 64.6498 15.3753L63.2598 21.9653C63.2898 20.8353 63.3898 19.7153 63.4798 18.5953C63.5998 17.4753 63.7298 16.3553 63.8898 15.2353C64.2198 13.0053 64.6498 10.7753 65.4398 8.60529C65.6498 8.06529 65.8898 7.52529 66.2098 7.00529C66.5398 6.50529 66.9298 5.92529 67.6898 5.68529C68.0698 5.56529 68.4898 5.61529 68.8198 5.76529C69.1398 5.89529 69.4298 6.12529 69.6498 6.36529C70.0998 6.86529 70.3098 7.45529 70.4698 8.02529C71.0098 10.3253 70.8098 12.6053 70.4098 14.8253Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.33062 8.2386) rotate(76.4029) scale(13.8699 7.98668)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(64.5805 8.17477) rotate(103.597) scale(13.8699 7.98668)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
